/* ⚠️ GENERATED from app/services/postEdit.ts by gen-twins.mjs — edit the TypeScript, not this. */
/* ═══════════════════════════════════════════════════════════════════════════
   ✏️ postEdit.ts — what an edit writes. One rule for both clients.

   Only what changed is written; nothing at all when nothing changed (the sheet
   just closes). The words are the post's `content`; for a video the hashtags
   and the safety notice are re-read from them (services/videoTags, passed in so
   this stays plain logic). A poll keeps its words — they are its question.
   The tags are the ASK (taggedUids / tagNames); `tagsChanged` tells the caller
   to let the server decide again (tagRoutes.announce).
   ═══════════════════════════════════════════════════════════════════════════ */
export const EDIT_MAX = 5000;
export function editPatch(post, i, deps) {
  const p = post || {};
  const fields = {};
  const text = String(i.text || '').trim().slice(0, EDIT_MAX);
  if (!i.isPoll && text !== String(p.content || '').trim()) {
    const hasMedia = (Array.isArray(p.media) ? p.media.length > 0 : false) || !!p.imageUrl || !!p.videoUrl || !!p.linkUrl;
    if (!text && !hasMedia) return null; // a text post cannot be edited into nothing
    fields.content = text;
    if (i.isVideo) {
      fields.hashtags = deps.tagsForPost(text, true);
      fields.safety = deps.safetyForPost(text, true) || null;
    }
  }
  const aud = i.audience === 'friends' ? 'friends' : 'everyone';
  if (aud !== (p.audience === 'friends' ? 'friends' : 'everyone')) fields.audience = aud;
  if (!!i.commentsEnabled !== (p.commentsEnabled !== false)) fields.commentsEnabled = !!i.commentsEnabled;
  const want = (i.tags || []).filter(x => x && x.uid && x.uid !== p.userId).slice(0, 20);
  const before = Array.isArray(p.taggedUids) ? p.taggedUids.map(String) : [];
  const status = p.tagStatus || {};
  const keptBefore = before.filter(u => status[u] !== 'removed' && status[u] !== 'declined');
  const ids = want.map(x => String(x.uid));
  const tagsChanged = ids.length !== keptBefore.length || ids.some((u, k) => u !== keptBefore[k]);
  if (tagsChanged) {
    fields.taggedUids = ids;
    const names = Object.assign({}, p.tagNames || {});
    for (const x of want) if (x.name) names[String(x.uid)] = String(x.name);
    fields.tagNames = names;
  }
  if (!Object.keys(fields).length) return null;
  return {
    fields,
    tagsChanged
  };
}

/** Has this post been edited? (the card's "Edited") */
export function isEdited(post) {
  return !!(post && post.editedAt);
}
